import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { PaymentApi, LoopBackAuth } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { PAYMENT_METHOD } from '../../../enums';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent extends BasicList {
  PAYMENT_METHOD: typeof PAYMENT_METHOD = PAYMENT_METHOD;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'referenceNumber', placeholder: 'Order Reference', exact: true },
      { name: 'method', placeholder: 'Payment Method', exact: true, options: PAYMENT_METHOD },
      { name: 'reference', placeholder: 'Reference', exact: true },
      { name: 'paypalId', placeholder: 'Payer id', exact: true }
    ],
    filters: {}
  };
  constructor(
    private paymentApi: PaymentApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        userId: this.getUser().id
      },
      order: 'dateCreated DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.paymentApi.search.bind(this.paymentApi),
        deleteById: this.paymentApi.deleteById.bind(this.paymentApi)
      },
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}

